module.exports = __webpack_public_path__ + "media/components/assets/img/pic/piggybank-43331351257da5d061be4ada746c81c7.svg";